/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { localStorageSingleton } from '@zcode/nr-utils'

const FILTERS_COUNT_STORAGE_KEY = 'mixpanel_prev_filters_count'

export const clearPreviousFiltersCount = () => {
  localStorageSingleton.del(FILTERS_COUNT_STORAGE_KEY)
}

export const setPreviousFiltersCount = (count: number) => {
  localStorageSingleton.set(FILTERS_COUNT_STORAGE_KEY, count)
}

export const getPreviousFiltersCount = () => {
  return localStorageSingleton.get(FILTERS_COUNT_STORAGE_KEY)
}
